const apiConfigs = {
  "regional": {
    "apiHost": "https://api.mit.edu",
    "paths": {
      "apiPath": "voip-v2",
      "digitalId": "digital-id-v1"
    }
  },
  "global": {
    "apiHost": "https://voip.mit.edu/api",
    "paths": {
      "apiPath": "voip/v2",
      "digitalId": "digital-id/v1"
    }
  }
};
export default apiConfigs;